import ThePlatinum from '../images/real-estates/ThePlatinum.jpg';
import CrystalJade from '../images/real-estates/CrystalJade.jpg';
import Notara from '../images/real-estates/Notara.jpg';
import TheImperial from '../images/real-estates/TheImperial.jpg';
import CampusNest from '../images/real-estates/CAMPUSNEST.jpg';
import GoldenUrban from '../images/real-estates/GOLDENURBAN.jpg';

const Listings = [
        {
            id: 1,
            name: "The Platinum",
            image: ThePlatinum,
            location: "Agios Dimitrios, Athens, Greece",
            sp1: "Blend of modern and classicBlend of modern and classic",
            sp2: "Large windows for natural light",
            sp3: "Luxurious and refined design",
            sp4: "Prime location in Agios Dimitrios near supermarkets and daily amenities",
            sp5: "Close to the Ellinikon mega-development, just 10 minutes by Metro",
            sp6: "Unique and charming cultural community",
            sp7: "Picturesque natural scenery",
            sp8: "",
            sp9: "",
            sp10: ""
        },
        {
            id: 2,
            name: "Crystal Jade",
            image: CrystalJade,
            location: "Drapetsona, Athens, Greece",
            sp1: "Convenient transportation by bus, tram, metro, and cruise terminals",
            sp2: "Close to famous tourist attractions: Acropolis and Syntagma",
            sp3: "Class A design in Mediterranean style",
            sp4: "Spacious terrace and breezy balcony",
            sp5: "Luxurious European-standard interiors",
            sp6: "Strategic location with many surrounding amenities",
            sp7: "",
            sp8: "",
            sp9: "",
            sp10: ""
        },
        {
            id: 3,
            name: "Notara Elegant",
            image: Notara,
            location: "Piraeus, Athens, Greece",
            sp1: "300 meters from Piraeus port",
            sp2: "18 minutes to Syntagma Square",
            sp3: "Convenient transportation, near metro",
            sp4: "Just 3 minutes to Port Gate E9",
            sp5: "Easy access to ferries to famous islands",
            sp6: "Class A design, Mediterranean style",
            sp7: "Luxurious interiors, European quality",
            sp8: "Approximately 300 meters from the beach",
            sp9: "",
            sp10: ""
        },
        {
            id: 4,
            name: "The Imperial",
            image: TheImperial,
            location: "Dafni, Athens, Greece",
            sp1: "Only 6 minutes walk from Dafni Metro station",
            sp2: "Minimum investment of just 250,000 EUR",
            sp3: "Acropolis, Syntagma, Lycabettus: about a 10-minute drive",
            sp4: "Alimos, Glyfada, Asteras, Kalamaki beach: 12-20 minutes by car",
            sp5: "Near the luxurious Ellinikon mega-development: 5 metro stations",
            sp6: "Class A design, Mediterranean style",
            sp7: "Luxurious interiors, European quality",
            sp8: "Modern and elegant living space",
            sp9: "",
            sp10: ""
        },
        {
            id: 5,
            name: "Campus Nest",
            image: CampusNest,
            location: "Gerakas, Greece",
            sp1: "Close to the famous Acropolis ancient site",
            sp2: "Well-developed transportation system",
            sp3: "Only 10-15 km to beautiful beaches",
            sp4: "Visit the vast Attica Zoo",
            sp5: "Just 9 minutes to the Metro station",
            sp6: "Amenities within a 2 to 4 minutes walk",
            sp7: "Easy access to the airport and universities",
            sp8: "Strategic area with diverse amenities",
            sp9: "Ideal and safe living environment",
            sp10: ""
        },
        {
            id: 6,
            name: "Golden Urban",
            image: GoldenUrban,
            location: "Piraeus, Athens, Greece",
            sp1: "Vibrant economic center of Athens",
            sp2: "Near the largest port in Europe, Piraeus",
            sp3: "Modern and convenient transportation",
            sp4: "Metro line 3 connects to the international airport",
            sp5: "Unique cultural festivals throughout the year",
            sp6: "Spacious living room with natural light",
            sp7: "3-bedroom apartments with high investment potential",
            sp8: "",
            sp9: "",
            sp10: ""
        }
    ]

export default Listings
